const e = () => typeof window > "u" ? !1 : localStorage.getItem("debug") === "true";
export {
  e as isInDebugMode
};
